module.exports = __webpack_public_path__ + "static/media/users-crown.8c7b4ece.svg";